// Facebook domain verification — injects the verification <meta> tag into <head>.
// The project has no editable index.html, so the tag is added at runtime.

const VERIFICATION_TOKEN = 'zmouhvmlkjkya60umdlhqj5u13ttpm'

export function initFacebookDomainVerification(): void {
  if (typeof document === 'undefined') return

  const selector = 'meta[name="facebook-domain-verification"]'
  if (document.head.querySelector(selector)) return

  const meta = document.createElement('meta')
  meta.name = 'facebook-domain-verification'
  meta.content = VERIFICATION_TOKEN
  document.head.appendChild(meta)
}
